import { Suspense } from "react";
import Loader from "../../Layout/Loader/Loader";

export const withSuspense = (Component: JSX.Element) => (
  <Suspense fallback={<Loader />}>{Component}</Suspense>
);
